import { Card, Collection, Grid, Link } from "@aws-amplify/ui-react";
import { Dialog } from "@mui/material";

import { getUrl } from "aws-amplify/storage";
import { I18n } from "aws-amplify/utils";

import React, { useState } from "react";
import { FaPlay, FaUpload } from "react-icons/fa6";
import { hasAccess } from "../acl/groups";
import { UserVideo } from "../models/UserVideo";

interface VideoCarouselProps {
  videos: UserVideo[];
  onVideoUploadClick: () => void;
  groups: string[];
}

const VideoCarousel: React.FC<VideoCarouselProps> = ({
  videos,
  onVideoUploadClick,
  groups,
}) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");

  const onCloseDialog = () => {
    setOpen(false);
  };

  const setSignedUrl = async (video: UserVideo) => {
    // split video key to get url
    const videoKeyParts = video.key.split("/");
    let videoKey = video.key;
    if (videoKeyParts.length > 2) {
      videoKey = videoKeyParts.slice(2).join("/");
    }
    const signedUrl = await getUrl({
      key: videoKey,
      options: {
        accessLevel: "protected",
        targetIdentityId: video.identityId,
      },
    });
    setUrl(signedUrl.url.href);
  };

  const videoList = hasAccess(groups, "videos", "create")
    ? [...videos, { key: "add-video", identityId: "" }]
    : videos;
  return (
    <>
      <Grid>
        <Collection
          items={videoList}
          type="list"
          direction="row"
          wrap="wrap"
          alignContent="flex-start"
        >
          {(video: UserVideo, index: number) =>
            video.key === "add-video" ? (
              <Card
                key="add-video"
                variation="outlined"
                borderRadius="medium"
                alignSelf="flex-start"
                backgroundColor="green.20"
              >
                <Link onClick={onVideoUploadClick}>
                  <FaUpload aria-label={I18n.get("Upload Videos")} />
                </Link>
              </Card>
            ) : (
              <Card
                key={index}
                variation="outlined"
                borderRadius="medium"
                alignSelf="flex-start"
              >
                <Link
                  onClick={() => {
                    setSignedUrl(video);
                    setOpen(true);
                  }}
                >
                  <FaPlay aria-label={I18n.get("Play Videos")} />
                </Link>
              </Card>
            )
          }
        </Collection>
      </Grid>
      <Dialog open={open} onClose={onCloseDialog}>
        <video controls>
          <source src={url} />
        </video>
      </Dialog>
    </>
  );
};

export default VideoCarousel;
